import { Injectable } from '@angular/core';
import {
  Actions,
  Observable,
  Action,
  Effect,
  ofType,
  AppTypes,
  InitializeClub,
  map,
  AppFields,
  switchMap,
  InitializeProgram,
  InitializeUser,
  GetTransactionDetails,
  ClubProgram,
  Club,
  ValidateUser,
  GetClubPlayers,
  GetClubProgramFees,
  GetTeamPlayers,
  GetStaffEvaluations,
  GetPlayerFormTypes,
  GetAllStates,
  GetAllCountries,
  GetUserRoles,
  GetClubOverallScore,
  GetClubTeamsStat,
  GetClubProductUsage,
  GetPlayerPositions,
  GetStaffList,
  GetTeamsList,
  GetClubTeamPlayers,
  GetClubCollegeRecruiting,
  GetSchedulesLeftNavCount,
  GetCollegeLeftNavCounts,
  GetCollegeDetails,
  GetPlayerAttendingThisCollegeData,
  GetSubscriptionPlans,
  GetClubPlayersList,

  GetTeamPlayerList
} from './app.models';
import { ProgramService, ClubMemberService, PlayerService, AssociationRegistrationService, ClubService } from '../services';
import { CollegeRecrutingCenterService } from '../services/college-recruiting-center.service';
import { UserInfo, TransactionDetail } from '../interfaces';
import { FinancialsService } from '../services';
import { TokenService } from '../services/token.service';
import { Router } from '@angular/router';
import { StorageUtil, filter, of, TeamsList } from '../models';
import { TryoutProgramService } from '../services/tryout_Services/tryout-program.service';
import { EvaluationsService } from '../services/evaluations.service';
import { ClubTeamsService } from '../services/club-teams.service';
import * as lodash from 'lodash';
import { MyTeamsService } from '../services/my-teams.service';

@Injectable()
export class AppEffects {
  private user;
  club: any;

  constructor(
    private as: Actions,
    private router: Router,
    private programService: ProgramService,
    private collegeRecrutingCenterService: CollegeRecrutingCenterService,
    private evaluationService: EvaluationsService,
    private clubMemberService: ClubMemberService,
    private financialsService: FinancialsService,
    private tokenService: TokenService,
    private tryoutService: TryoutProgramService,
    private playerService: PlayerService,
    private teamService: MyTeamsService,
    private clubTeamsService: ClubTeamsService,
    private associationService: AssociationRegistrationService,
    private clubService: ClubService,
  ) { }

  @Effect() initializeClub: Observable<Action> = this.as.pipe(
    ofType(AppTypes.InitializeClub),
    switchMap((a: InitializeClub) =>
      this.programService.getClubById(a.payload && a.payload.clubId ? a.payload.clubId : StorageUtil.clubID).pipe(
        filter(club => !!club),
        map((club: any) => {
          if (club.homecolor) {
            this.clubService.getJerseyLogo(club.homecolor).subscribe(s => club.homeJersey = s);
          } else {
            club.homeJersey = 'https://s3.amazonaws.com/images.totalglobalsports.com/Sample-Jersey.png'; // 'http://admin.totalglobalsports.com/Images/ClubImages/JerseyLogos/Red.png';
          }
          if (club && club.awaycolor) {
            this.clubService.getJerseyLogo(club.awaycolor).subscribe(s => club.awayJersey = s);
          } else {
            club.awayJersey = 'https://s3.amazonaws.com/images.totalglobalsports.com/Sample-Jersey.png'; //'http://admin.totalglobalsports.com/Images/ClubImages/JerseyLogos/Red.png';
          }

          return {
            type: AppTypes.UpdateState,
            payload: {
              [AppFields.Club]: club
            }
          };
        })
      )
    )
  );

  @Effect() initializeProgram: Observable<Action> = this.as.pipe(
    ofType(AppTypes.InitializeProgram),
    switchMap((a: InitializeProgram) =>
      this.programService.getProgram(String(a.payload.programId)).pipe(
        map((program: ClubProgram) => ({
          type: AppTypes.UpdateState,
          payload: {
            [AppFields.Program]: program
          }
        }))
      )
    )
  );

  @Effect() initializeUser: Observable<Action> = this.as.pipe(
    ofType(AppTypes.InitializeUser),
    switchMap((a: InitializeUser) =>
      this.clubMemberService.getUser(a.payload.userId).pipe(
        map((user: any) => ({
          type: AppTypes.UpdateState,
          payload: {
            [AppFields.User]: user && new UserInfo(user)
          }
        }))
      )
    )
  );

  @Effect() getTransactionDetails: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetTransactionDetails),
    switchMap((a: GetTransactionDetails) =>
      this.financialsService.getTransactionDetails(a.payload.programId).pipe(
        map((details: TransactionDetail[]) => ({
          type: AppTypes.UpdateState,
          payload: {
            [AppFields.TransactionDetails]: details
          }
        }))
      )
    )
  );

  @Effect() validateUser: Observable<Action> = this.as.pipe(
    ofType(AppTypes.ValidateUser),
    switchMap((a: ValidateUser) =>
      this.tokenService.validateTeamUser(StorageUtil.oldParams).pipe(
        map((res: any) => {
          if (res) {
            let user: UserInfo;
            const staffRole = res.roles.find(r => r.programRoleTypeID === 2);
            user = new UserInfo({ ...res, userProgramRole: staffRole ? staffRole.programRoleID : 0 });
            const isRedirect = this.router.url.includes('redirect');

            if (StorageUtil.oldParams.clubId) {
              localStorage.setItem('clubId', String(StorageUtil.oldParams.clubId));
            }
            localStorage.setItem('userId', String(user.userID));
            localStorage.setItem('tokenValue', String(StorageUtil.oldParams.tokenValue));
            if (StorageUtil.oldParams.rid) {
              user.clubUserRoles.push(+StorageUtil.oldParams.rid);
            }
            if (StorageUtil.oldParams.teamId) {
              localStorage.setItem('teamId', String(StorageUtil.oldParams.teamId));
            }

            if (isRedirect) {
              if (
                res.staff &&
                StorageUtil.oldParams.redirect &&
                StorageUtil.oldParams.redirect.includes('/programs/active')
              ) {
                this.router.navigate(['/tryoutprogram/active']);
              } else if (StorageUtil.oldParams.redirect) {
                this.router.navigate([StorageUtil.oldParams.redirect]);
              }
            }
            this.user = user;
          } else {
            this.router.navigate(['401']);
            this.user = null;
          }
        })
      )
    ),
    switchMap(() => StorageUtil.teamId
      ? this.teamService.getAdminTeamClubData(StorageUtil.teamId).pipe(map(res => (this.club = res, res.clubID)))
      : of(StorageUtil.clubID)),
    switchMap(clubId => (StorageUtil.clubID = clubId, this.clubTeamsService.getClubTeamsList(clubId, 1, 0))),
    map(teams => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.User]: this.user || new UserInfo(),
        [AppFields.TeamAccount]: this.user && !!StorageUtil.teamId,
        [AppFields.EvalautionAccount]: this.user && !StorageUtil.oldParams.clubId,
        [AppFields.TeamsList]: lodash.sortBy(teams, 'teamName'),
        [AppFields.MyTeam]: StorageUtil.teamId ? teams.find(t => t.teamID === StorageUtil.teamId) || null : null,
        [AppFields.Club]: this.club || null
      }
    }))
  );

  @Effect() getClubPlayers: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetClubPlayers),
    switchMap((a: GetClubPlayers) =>
      this.programService.getClubPlayers(
        a.payload.clubId || StorageUtil.clubID,
        a.payload.teamId,
        0,
        a.payload.paymentStatus
      )
    ),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.Players]: lodash.sortBy(res.map(p => ({
          ...p,
          birthYear: p.dob ? new Date(p.dob).getFullYear() : 0,
          name: `${p.lastName}, ${p.firstName}`
        })), 'name')
      }
    }))
  );

  @Effect() getClubPlayersList: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetClubPlayersList),
    switchMap((a: GetClubPlayersList) =>
      this.programService.getClubPlayersList(
        a.payload.clubId || StorageUtil.clubID,
        a.payload.teamId,
        0,
      )
    ),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.PlayersList]: lodash.sortBy(res.map(p => ({
          ...p,
          birthYear: p.dob ? new Date(p.dob).getFullYear() : 0,
          name: `${p.lastName}, ${p.firstName}`
        })), 'name')
      }
    }))
  );

  @Effect() getClubTeamPlayers: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetClubTeamPlayers),
    switchMap((a: GetClubTeamPlayers) =>
      this.clubTeamsService.getClubTeamPlayersList(
        a.payload.clubId || StorageUtil.clubID,
        a.payload.teamId || StorageUtil.teamId,
        0
      )
    ),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.TeamPlayers]: lodash.sortBy(res.clubTeamPlayersList.map(p => ({
          ...p,
          birthYear: p.dob ? new Date(p.dob).getFullYear() : 0,
          name: `${p.lastName}, ${p.firstName}`
        })), 'name')
      }
    }))
  );

  @Effect() GetTeamPlayers: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetTeamPlayers),
    switchMap((a: GetTeamPlayers) =>
      this.programService.getClubPlayers(
        a.payload.clubId || StorageUtil.clubID,
        a.payload.teamId,
        a.payload.programId,
        true
      )
    ),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.TeamPlayers]: res.map(p => ({ ...p, birthYear: p.dob ? new Date(p.dob).getFullYear() : 0 }))
      }
    }))
  );

  @Effect() GetStaffEvalautions: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetStaffEvaluations),
    switchMap((a: GetStaffEvaluations) =>
      this.evaluationService.loadEvaluationsByStaffID(a.payload.userId, 0)
    ),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.StaffEvaluations]: res
      }
    }))
  );

  @Effect() getClubProgramFees: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetClubProgramFees),
    switchMap((a: GetClubProgramFees) =>
      this.tryoutService.getTryoutInvitePrograms(
        a.payload.clubId || StorageUtil.clubID,
        a.payload.teamId
      )
    ),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.ClubProgramFees]: res
      }
    }))
  );

  @Effect() getPlayerFormTypes: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetPlayerFormTypes),
    switchMap((a: GetPlayerFormTypes) => this.playerService.getFormTypes()),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.PlayerFormTypes]: res
      }
    }))
  );

  @Effect() getAllStates: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetAllStates),
    switchMap((_: GetAllStates) => this.associationService.getAllSates()),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.AllStates]: res
      }
    }))
  );

  @Effect() getAllCountries: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetAllCountries),
    switchMap((_: GetAllCountries) => this.associationService.getAllCountries()),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.AllCountries]: res
      }
    }))
  );

  @Effect() getTeamUserRoles: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetUserRoles),
    switchMap((_: GetUserRoles) => this.playerService.getUserRoles()),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.UserRoles]: res
      }
    }))
  );

  @Effect() getClubOverallScore: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetClubOverallScore),
    switchMap((a: GetClubOverallScore) => this.clubService.getClubOverallScore(a.payload.clubID)),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.ClubOverallScore]: res
      }
    }))
  );

  @Effect() getClubTeamsStat: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetClubTeamsStat),
    switchMap((a: GetClubTeamsStat) => this.clubService.getClubTeamsStat(a.payload.clubID)),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.ClubTeamsStat]: res
      }
    }))
  );

  @Effect() getClubProductUsage: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetClubProductUsage),
    switchMap((a: GetClubProductUsage) => this.clubService.getProductUsageData(a.payload.clubID)),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.ClubProductUsage]: res
      }
    }))
  );

  @Effect() getPlayerPositions: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetPlayerPositions),
    switchMap((a: GetPlayerPositions) => this.clubService.getPlayerPositions(a.payload.clubID)),
    map(res => ({
      type: AppTypes.UpdateState,
      payload: {
        [AppFields.PlayerPositions]: res
      }
    }))
  );

  @Effect() getStaffList: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetStaffList),
    switchMap((a: GetStaffList) => this.associationService.getStaffMembersListByClubID(a.payload.clubID)),
    map((res) => (
      {
        type: AppTypes.UpdateState,
        payload: {
          [AppFields.ClubStaff]: lodash.sortBy(res.map(p => ({
            ...p,
            status: !!p.password,
            name: `${p.lastName}, ${p.firstName}`.trim(),
            fullName: `${p.firstName} ${p.lastName}`.trim(),
          })), 'name')
        }
      }
    ))
  );

  @Effect() getTeamsList: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetTeamsList),
    switchMap((a: GetTeamsList) => this.clubTeamsService.getClubTeamsList(StorageUtil.clubID, 1, 0)),
    map((res) => (
      {
        type: AppTypes.UpdateState,
        payload: {
          [AppFields.TeamsList]: lodash.sortBy(res, 'teamName')
        }
      }
    ))
  );

  @Effect() getSchedulesLeftNavCount: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetSchedulesLeftNavCount),
    switchMap((a: GetSchedulesLeftNavCount) =>
      this.teamService.getSchedulesLeftNavCount(a.payload.teamID, a.payload.userID).pipe(
        map((res: any) => ({
          type: AppTypes.UpdateState,
          payload: {
            [AppFields.SchedulesLeftNavCount]: res
          }
        }))
      )
    )
  );

  @Effect() getCollegeLeftNavCounts: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetCollegeLeftNavCounts),
    switchMap((a: GetCollegeLeftNavCounts) =>
      this.collegeRecrutingCenterService.getCollegeLeftNavCounts(a.payload.clubID, a.payload.collegeID, a.payload.collegeProgramID,a.payload.teamID).pipe(
        map((res: any) => ({
          type: AppTypes.UpdateState,
          payload: {
            [AppFields.GetCollegeLeftNavCounts]: res
          }
        }))
      )
    )
  );

  @Effect() getCollegeDetails: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetCollegeDetails),
    switchMap((a: GetCollegeDetails) =>
      this.collegeRecrutingCenterService.getCollegeDetails( a.payload.collegeID, a.payload.collegeProgramID).pipe(
        map((res: any) => ({
          type: AppTypes.UpdateState,
          payload: {
            [AppFields.GetCollegeDetails]: res
          }
        }))
      )
    )
  );

  @Effect() getPlayerAttendingThisCollegeData: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetPlayerAttendingThisCollegeData),
    switchMap((a: GetPlayerAttendingThisCollegeData) =>
      this.collegeRecrutingCenterService.getPlayerAttendingThisCollegeData(a.payload.clubID, a.payload.collegeID, a.payload.teamID).pipe(
        map((res: any) => ({
          type: AppTypes.UpdateState,
          payload: {
            [AppFields.GetPlayerAttendingThisCollegeData]: res
          }
        }))
      )
    )
  );

  @Effect() getSubscriptionPlans: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetSubscriptionPlans),
    switchMap((a: GetSubscriptionPlans) =>
      this.collegeRecrutingCenterService.getClubTeamSubscriptionPlansWithPlanName(a.payload.clubID, a.payload.teamID).pipe(
        map((res: any) => ({
          type: AppTypes.UpdateState,
          payload: {
            [AppFields.SubscriptionPlans]: res
          }
        }))
      )
    )
  );
  @Effect() getTeamPlayerList: Observable<Action> = this.as.pipe(
    ofType(AppTypes.GetTeamPlayerList),
    switchMap((a: GetTeamPlayerList) =>
      this.teamService.getTeamPlayerList(a.payload.teamID, 0, +StorageUtil.userID).pipe(
        map((res: any) => ({
          type: AppTypes.UpdateState,
          payload: {
            [AppFields.GetTeamPlayerList]: res
          }
        }))
      )
    )
  );

}



// WEBPACK FOOTER //
// ./src/app/store/app.effects.ts